import styled from 'styled-components';
import { Type, HeaderType } from '../types'

export const HeaderST = styled.header.attrs((props: HeaderType) => ({
  open: props.open,
  theme: props.theme
})) <HeaderType>`
    background-color: ${(props: HeaderType) => props.open ? props.theme.header.headerBackground : props?.theme?.header?.headerBackgroundClose};
`

export const ButtonMenu = styled.button.attrs((props: HeaderType) => ({
  open: props.open,
  theme: props.theme
})) <HeaderType>`
    background-color: ${(props: HeaderType) => props.open ? props.theme.header.buttonOpen : props.theme.header.button};
`

export const SpanMenu = styled.span.attrs((props: HeaderType) => ({
  open: props.open,
  theme: props.theme
})) <HeaderType>`
    background-color: ${({ theme, open }: HeaderType) => open ? theme.header.spansButtonVariation : theme.header.spansButton};
`

export const Menu = styled.div`
    background-color: ${({ theme }: Type) => theme.header.menuBackground};
    color: ${({ theme }: Type) => theme.header.menuText};
`

export const Logo = styled.img`
  width: ${(props: Type) => props.theme.imagesConfig.logo};
`

export const Points = styled.p`
  color: ${({ theme }: Type) => theme.header.points};
`